
import { defineComponent, computed, onMounted } from 'vue'
import _staffData from '@/../public/json/staff.json'
import { useRenderedEventDispatcher } from '@/plugins/renderedEventDispatcher'

import '@/assets/scss/pages/staff.scss'
import { useStore } from '@/store'

export default defineComponent({
  name: 'Staff',
  setup () {
    const { languagePack } = useStore()
    const staffData = computed(() => {
      const groupSequence = ['coordinator', 'secretary', 'program', 'field', 'finance', 'it', 'marketing', 'photo', 'sponsor', 'streaming']
      return _staffData
        .sort((a, b) => groupSequence.indexOf(a.tid) - groupSequence.indexOf(b.tid))
        .map((group) => {
          return {
            tid: group.tid,
            name: group.name,
            staffs: [
              ...group.chiefs.map((chief) => ({ ...chief, isChief: true })),
              ...group.members.map((chief) => ({ ...chief, isChief: false }))
            ]
          }
        })
    })

    const dispatchRenderedEvent = useRenderedEventDispatcher()

    onMounted(() => {
      dispatchRenderedEvent()
    })

    return {
      languagePack,
      staffData
    }
  }
})
